/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Save_CalendarInputs */

const en_settings_save_calendar = /** @type {(inputs: Settings_Save_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save calendar settings`)
};

const he_settings_save_calendar = /** @type {(inputs: Settings_Save_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שמירת הגדרות יומן`)
};

/**
* | output |
* | --- |
* | "Save calendar settings" |
*
* @param {Settings_Save_CalendarInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_save_calendar = /** @type {((inputs?: Settings_Save_CalendarInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Save_CalendarInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_save_calendar(inputs)
	return he_settings_save_calendar(inputs)
});